/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseTenantPublicSettingsData } from './genericApiResponseTenantPublicSettingsData';
import type { GenericApiResponseTenantPublicSettingsMessage } from './genericApiResponseTenantPublicSettingsMessage';
import type { GenericApiResponseTenantPublicSettingsPagination } from './genericApiResponseTenantPublicSettingsPagination';
import type { GenericApiResponseTenantPublicSettingsError } from './genericApiResponseTenantPublicSettingsError';

export interface GenericApiResponseTenantPublicSettings {
  data?: GenericApiResponseTenantPublicSettingsData;
  message?: GenericApiResponseTenantPublicSettingsMessage;
  pagination?: GenericApiResponseTenantPublicSettingsPagination;
  error?: GenericApiResponseTenantPublicSettingsError;
  statusCode?: number;
}
